import TransactionList from './TransactionList';
import TransactionShow from './TransactionShow';

export default {
  list: TransactionList,
  show: TransactionShow,
};
